<template>
	<div class="YWBK">
		<div class="content mb50 yw">
			<div class="content_2 c3 lh7">
				<div class="f30">业务板块</div>
				<div class="f20 mb45">BUSINESS SECTOR</div>
				<transition name="el-zoom-in-top">
					<div v-show="show" style="transition: all 0.6s;-webkit-transition: all 0.6s;">
						<el-row>
							<template v-for="(item, i) in yw">
								<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
									<div class="yw_item tz" :class="{'br0': i%2!=0, 'bb0 pt50': i>1, 'pb50': i<2}">
										<div class="mb20">
											<el-image style="width: 150px; height: 125px" :src="item.img"
												:fit="'contain'"></el-image>
											<div class="f24 mt20">{{item.title}}</div>
										</div>
										<div class="html f18 c9 lh7" v-html="item.html"></div>
									</div>
								</el-col>
							</template>
						</el-row>
					</div>
				</transition>
			</div>
		</div>
		<div class="pt50 bk">
			<div class="content">
				<div class="content_2">
					<div class="f24 tz mb50">四大业务板块现有项目</div>
					<div class="bff yy mb20">
						<el-row>
							<template v-for="(item, i) in bk">
								<el-col class="plr25 b_k" :class="{'b_k_2': i == 1}" :xs="24" :sm="24" :md="8" :lg="8" :xl="8" v-if="i < 3">
									<transition name="el-zoom-in-top">
										<div v-show="show" class="b_item ptb20">
											<div class="tz">
												<el-image style="width: 60px; height: 60px" :src="item.img"
													:fit="'contain'"></el-image>
												<div class="f24 pt20 pb30">{{item.title}}</div>
											</div>
											<div class="f14 lh5 bor1 p10 mt10 boxbor zlz info" v-for="x in item.items">
												<span>{{x}}</span>
											</div>
										</div>
									</transition>
								</el-col>
							</template>
						</el-row>
					</div>
					<div class="bff yy ptb20 plr15">
						<div class="m_bk">
							<div class="tz gyl">
								<el-image style="width: 60px; height: 60px" :src="require('@/assets/bk_4.png')"
									:fit="'contain'"></el-image>
								<div class="f24 pt20 pb30">供应链服务</div>
							</div>
							<el-row :gutter="30">
								<template v-for="(item, i) in bk">
									<el-col class="borr1 pb30" :class="{'bor0i': i==bk.length-1}" :xs="24" :sm="24" :md="6" :lg="6" :xl="6" v-if="i >= 3">
										<transition name="el-zoom-in-top">
											<div v-show="show" class="k_item pt10">
												<div class="tz">
													<span>{{item.title}}</span>
												</div>
												<div class="f14 lh5 bor1 p10 mt10 boxbor zlz info" v-for="x in item.items">
													<span>{{x}}</span>
												</div>
											</div>
										</transition>
									</el-col>
								</template>
							</el-row>
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				show: false,
				yw: [{
						title: '物流规划咨询',
						html: `集合行业智慧，为客户提供生产物流规划、物流园区规划设计、物流企业管理咨询、物流业务流程优化等服务。`,
						img: require('@/assets/yw_1.png')
					},
					{
						title: '智能装备制造与集成',
						html: `利用自动识别技术、人工智能技术、数据挖掘技术、GIS技术，根据实际应用经验，以WMS/WCS为核心的软件系统平台，通过智能技术和智能装备的有效应用，实现客户个性化服务的标准化。`,
						img: require('@/assets/yw_2.png')
					},
					{
						title: '智慧物流软件开发',
						html: `为客户提供软件开发、信息化解决方案设计、企业管理模式设计、业务流程重组等服务，帮助客户实现全面数字化与网络化。`,
						img: require('@/assets/yw_3.png')
					},
					{
						title: '供应链服务',
						html: `依据客户的不同要求，提供运输、仓储、内外物流配送等相关服务。助您节拍提升、产能提升、降低物流成本。`,
						img: require('@/assets/yw_4.png')
					}
				],
				bk: [{
						title: '物流规划咨询',
						items: [
							'一汽解放青岛汽车有限公司入厂物流优化项目',
							'一汽解放青岛汽车有限公司新能源项目厂内物流规划',
							'一汽集团蔚山工厂一厂B线外物流规划项目',
						],
						img: require('@/assets/bk_1.png')
					},
					{
						title: '智能装备制造与集成',
						items: [
							'一汽解放青岛汽车有限公司外物流仓储内部转运改善项目（牵引车AGV）',
							'一汽解放青岛配送中心上线供给智能化改造项目（叉车AGV）',
							'一汽轿车蔚山工厂供应商仓库内部转运智能化改造项目（叉车AGV）',
							'一汽解放青岛配送中心 发动机线SPS供给智能化改造项目（牵引车AGV）',
							'一汽解放青岛配送中心 内饰线SPS供给智能化改造项目（牵引车AGV）',
						],
						img: require('@/assets/bk_2.png')
					},
					{
						title: '智慧物流软件开发',
						items: [
							'一汽集团蔚山工厂物料管理软件（WMS）开发项目',
							'一汽解放青岛汽车有限公司中心仓储物料管理软件(WMS)开发项目',
							'天际汽车（长沙）制造基地 仓储物料管理软件（WMS）开发项目',
							'一汽集团蔚山工厂仓储中心 外物流入场车控系统(PACS)开发项目',
							'一汽集团蔚山工厂仓储中心裕新"天引"AGV智能调度管理系统项目',
							' 长春市大众物流装配有限责任公司物流可视化管理系统项目',
						],
						img: require('@/assets/bk_3.png')
					},
					{
						title: '仓储服务',
						items: [
							'一汽集团蔚山工厂一、二工厂全部车型国产化异地供应商零件仓储业务',
							'一汽集团蔚山工厂发传中心产前零件仓储配送业务',
							'一汽解放青岛工厂产前仓储业务',
						]
					},
					{
						title: '配送服务',
						items: [
							'一汽集团蔚山工厂一、二工厂订单分割零件配送业务',
							'一汽集团蔚山工厂二工厂标准件配送业务',
							'一汽集团蔚山工厂一、二工厂顺引零件配送业务',
							'一汽集团蔚山工厂一二工厂、发传中心车间内物流配送业务',
							'中国中车内物流服务',
							'东风裕隆内务流服务',
						]
					},
					{
						title: '装配服务',
						items: [
							'一汽集团蔚山工厂一工厂总装A线仪表、车门、底盘、一次内饰、二次内饰、17个模块的装配业务装配业务',
							'一汽集团蔚山工厂一工厂总装B线整条生产线装配业务',
							'中国中车生产线外包业务',
						]
					},
					{
						title: '运输服务',
						items: [
							'长春本地汽车零部件制造企业的市内运输业务',
							'长春市绿园区城西镇、西新镇村民饮用水配送服务',
							'京津冀、黑吉辽、江浙沪、川渝等多条线路的干线运输业务',
						]
					}
				]
			}
		},
		created() {

		},
		mounted() {
			this.$nextTick(() => {
				this.show = true
			})
		},
		methods: {
			look(url) {
				// console.log(url)
				window.open(url)
			}
		}
	}
</script>

<style lang="scss">
	.YWBK {
		padding: 65px 0 0;
		
		.borr1 {
			border-right: 1px solid #adadad;
			@media screen and (max-width: 768px) {
				border: none;
			}
		}
		
		.b_k {
			border: 1px solid #adadad;
		}
		
		.b_k_2 {
			border-left: none;
			border-right: none;
		}
		
		@media screen and (max-width: 768px) {
			.m_bk {
				border: 1px solid #adadad;
				padding: 0 25px;
				.pb30 {
					padding-bottom: 20px;
				}
				.pt10 {
					padding: 0;
				}
				.tz span {
					margin-top: 0!important;
				}
			}
		}

		.yw_item {
			border-right: 1px solid #c6c9cb;
			border-bottom: 1px solid #c6c9cb;

			&.br0 {
				border-right: 0;
			}

			&.bb0 {
				border-bottom: 0;
			}

			.html {
				width: 400px;
				max-width: 100%;
				margin: 0 auto;
				height: 120px;
			}

			@media screen and (max-width: 768px) {
				border: none;
				border-bottom: 1px solid #c6c9cb !important;
				padding: 20px 0 30px !important;

				.html {
					height: auto;
				}
			}
		}

		.bor1 {
			border-color: #c6c9cb;
		}

		.k_item {
			.tz span {
				display: inline-block;
				background-color: #e9edf0;
				font-size: 18px;
				color: #595959;
				line-height: 30px;
				padding: 0 20px;
				border-radius: 30px;
				margin-bottom: 20px;

				@media screen and (max-width: 768px) {
					margin: 10px 0;
				}
			}
		}

		.bff {
			@media screen and (max-width: 768px) {
				padding: 20px 2vw;
			}
		}

		.gyl {
			@media screen and (max-width: 768px) {
				padding: 20px 0 0;
			}
		}

		.info {
			height: 62px;

			@media screen and (max-width: 1570px) {
				height: 83px;
			}

			@media screen and (max-width: 1200px) {
				height: 104px;
			}

			@media screen and (max-width: 768px) {
				height: auto;
			}
		}

		.yw {
			@media screen and (max-width: 768px) {
				.f30 {
					font-size: 7vw;
					line-height: 1.2;
					text-align: center;
					margin-bottom: 20px;
				}

				.f20 {
					font-size: 16px;
					text-align: center;
					line-height: 1.2;
					margin-bottom: 30px;
				}

				.f18 {
					font-size: 16px;
				}

				padding-left: 2vw;
				padding-right: 2vw;
				box-sizing: border-box;

				img {
					width: 80%;
					margin: 0 auto;
				}
			}
		}

		.bk {
			padding-bottom: 65px;

			background: url(../../assets/hz.jpg) repeat top center;
			background-size: cover;
		}
	}
</style>
